// extracted by mini-css-extract-plugin
export default {"debtItem":"DebtHistorySection_debtItem__TfG1J","link":"DebtHistorySection_link__HBIDi","emptyListPlaceholder":"DebtHistorySection_emptyListPlaceholder__l2Gi2"};